module.exports = __webpack_public_path__ + "img/qr-menu-mobile-dark.d48e51e3.svg";